import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import GasDetailGraph from './gasDetailGraph/GasDetailGraph';
import GasGraphSearchBar from './gasGraphSearchBar/GasGraphSearchBar';

const GasGraph = (props) => {
  const gasCriterion = useSelector((store) => store.criterion).gas;
  const [searchMap, setSearchMap] = useState({
    moduleIdx: 1,
    beginDate: new Date(),
    endDate: new Date(),
    moduleScn: '0',
  });

  return (
    <section>
      <GasGraphSearchBar searchMap={searchMap} setSearchMap={setSearchMap} />
      <GasDetailGraph flag={props.flag} searchMap={searchMap} gasCriterion={gasCriterion} />
    </section>
  );
};

export default GasGraph;
